import cx from 'classnames';
import { Dispatch, SetStateAction } from 'react';
import style from '../../FilterPanel.module.scss';
import { FilterField, FilterState } from '../../types';

interface IProps {
  inputValue: string;
  field: FilterField;
  setValues: (val: FilterState) => void;
  values: FilterState;
}

const NumberInputField = ({ inputValue, field, setValues, values }: IProps) => {
  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    key: string
  ) => {
    const rawValue = e.target.value;
    const sanitizedValue = rawValue.replace(/[^\d,\s]/g, '');
    setValues({ ...values, [key]: sanitizedValue });
  };

  return (
    <div key={field.key} className={cx(style.filterItem, field.className)}>
      <label>{field.label}</label>
      <input
        type="text"
        className={style.autocompleteInput}
        value={inputValue}
        placeholder={field.placeholder || 'Введите'}
        onChange={(e) => handleInputChange(e, field.key)}
        disabled={field.disabled}
      />
    </div>
  );
};

export default NumberInputField;
